import { uniqueId } from 'lodash';

class IdealCurvePoint {
  static fromJs = (props) => {
    const { x, y } = props;
    return new IdealCurvePoint(x, y);
  };

  static copy = (otherPoint) => {
    return new IdealCurvePoint(otherPoint.x, otherPoint.y, otherPoint.id);
  };

  constructor(x, y, id = null) {
    this.x = parseFloat(x);
    this.y = parseFloat(y);
    this._id = id || uniqueId();
  }

  get id() {
    return this._id;
  }

  valid = () => {
    const errors = [];
    const newX = parseFloat(this.x);
    const newY = parseFloat(this.y);

    if (isNaN(newX) || isNaN(newY)) {
      errors.push('Values are required and must be numeric');
    }

    if (errors.length > 0) {
      this.errorMessage = errors.join(', ');
      return false;
    } else {
      this.errorMessage = null;
      this.x = newX;
      this.y = newY;
      return true;
    }
  };

  toJs = () => {
    return {
      x: this.x,
      y: this.y,
    }
  };
}

export { IdealCurvePoint };
